const numberFormat = new Intl.NumberFormat();
const moneyFormats = {};

export function formatNumber(value) {
  return value == null ? '—' : numberFormat.format(value);
}

// Amounts come as strings from the API; currency is the ad account's
export function formatMoney(value, currency) {
  if (value == null || value === '') return '—';
  if (!currency) return numberFormat.format(Number(value));
  moneyFormats[currency] ??= new Intl.NumberFormat(undefined, { style: 'currency', currency });
  return moneyFormats[currency].format(Number(value));
}

export function formatPercent(value) {
  return value == null ? '—' : `${Number(value).toFixed(2)}%`;
}

// OUTCOME_TRAFFIC -> Traffic, LINK_CLICKS -> Link clicks
export function humanize(value) {
  if (!value) return '—';
  const text = value.replace(/^OUTCOME_/, '').replace(/_/g, ' ').toLowerCase();
  return text[0].toUpperCase() + text.slice(1);
}

// Local calendar date as YYYY-MM-DD
export function isoDate(value) {
  const pad = (number) => String(number).padStart(2, '0');
  return `${value.getFullYear()}-${pad(value.getMonth() + 1)}-${pad(value.getDate())}`;
}

const compactFormat = new Intl.NumberFormat(undefined, { notation: 'compact', maximumFractionDigits: 1 });
const compactMoneyFormats = {};

// Axis ticks: 1.2K, $3.4K
export function formatCompact(value, currency) {
  if (value == null) return '';
  if (!currency) return compactFormat.format(value);
  compactMoneyFormats[currency] ??= new Intl.NumberFormat(undefined, {
    style: 'currency', currency, notation: 'compact', maximumFractionDigits: 1,
  });
  return compactMoneyFormats[currency].format(value);
}
